import React, { useEffect, useRef, useState } from 'react';
import { Breadcrumb, Button, message, Spin } from 'antd';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../../assets/nubit.png';
import { getRequest } from '../../utils/APICall';
import {
  HomeIcon,
  DocumentChartBarIcon,
} from '@heroicons/react/16/solid';
import moment from 'moment';
import { baselogo } from '../../utils/base64';
import { useSelector } from 'react-redux';

export default function ReportPayslipComponent() {
  const [searchparams] = useSearchParams();
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const getmonth = searchparams.get('month');
  const getyear = searchparams.get('year');
  const reportRef = useRef(null);
  const navigate = useNavigate()
  const { users } = useSelector((state) => state.user || {});
  useEffect(() => {
    const getPayslipReport = async () => {
      const res = await getRequest(`payslipReport?month=${getmonth}&year=${getyear}`);
      // console.log("response",res)
      if (res?.success) {
        setReportData(res?.data);
      }
      else{
        message.warning("Report does not exist for given Dates")
        navigate("/payslip")
      }
      setLoading(false);
    };

    

    if (getmonth && getyear) {
      getPayslipReport();
    } else {
      setLoading(false);
    }
  }, [getmonth, getyear]);
// console.log("get reponse ",reportData)

// useEffect(()=>{
//     if(users?.ROLE_TITLE != "HR"  || users.ROLE_TITLE != "Admin" ){
//      navigate('/login')
//     }
//   })


  const getFormattedDateTime = () => {
    const now = new Date();
    const options = { weekday: 'long', day: '2-digit', month: 'numeric', year: 'numeric' };
    const date = now.toLocaleDateString('en-GB', options).replace(/\//g, '-');
    const time = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return `${date} ${time}`;
  };
  const monthName = moment().month(getmonth - 1).format('MMMM');
  const generatePDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const rightMargin = 16;
    const logoWidth = 30; // width of logo
    const logoHeight = 15; // height of logo
    const logoX = pageWidth - logoWidth - rightMargin; // align right
    const logoY = 10; // vertical position
    doc.addImage(baselogo, 'PNG', logoX, logoY, logoWidth, logoHeight);
    // Header
    doc.setFontSize(16);
    doc.text("Payslip Report", 14, 20);
    doc.setFontSize(10);
    doc.text(`Month: ${monthName} | Year: ${getyear}`, 14, 28);
    doc.text(`Printed on: ${getFormattedDateTime()}`, 14, 34);
    doc.text("Printed By: Nizamuddin", 14, 40);

    const groupByDepartment = {};
    reportData.forEach(emp => {
      const dept = emp.TITLE || 'Employee';
      if (!groupByDepartment[dept]) groupByDepartment[dept] = [];
      groupByDepartment[dept].push(emp);
    });

    let finalY = 50;
    let grand = { gross: 0, benefits: 0, deduction: 0, total: 0 };

    Object.entries(groupByDepartment).forEach(([department, employees]) => {
      const body = [];
      let dept = { gross: 0, benefits: 0, deduction: 0, total: 0 };

      // Add employee data
      employees.forEach(emp => {
        const gross = parseFloat(emp.GROSSSALARY?.replace(/,/g, '') || 0);
        const benefits = parseFloat(emp.OTHERBENIFITS?.replace(/,/g, '') || 0);
        const deduction = parseFloat(emp.DEDUCTION?.replace(/,/g, '') || 0);
        const total = parseFloat(emp.TOTAL?.replace(/,/g, '') || 0);

        dept.gross += gross;
        dept.benefits += benefits;
        dept.deduction += deduction;
        dept.total += total;

        grand.gross += gross;
        grand.benefits += benefits;
        grand.deduction += deduction;
        grand.total += total;

        body.push([
          emp.FKEMPID,
          emp.FIRSTNAME,
          emp.DESIGNATIONS,
          emp.MONTHNAME,
          emp.YEAR,
          emp.GROSSSALARY,
          emp.OTHERBENIFITS,
          emp.DEDUCTION,
          emp.CHEQUENO,
          emp.TOTAL
        ]);
      });

      // Add department total row
      body.push([
        '', '', '', '', 'Department Total:',
        dept.gross.toLocaleString(),
        dept.benefits.toLocaleString(),
        dept.deduction.toLocaleString(),
        '',
        dept.total.toLocaleString()
      ]);

      // Department table with header
      doc.setFontSize(10);
      doc.text(`Department: ${department}`, 14, finalY);
      finalY += 2;

      autoTable(doc, {
        startY: finalY + 2,
        head: [[
          "Id",  "First Name","Designation", "Month", "Year",
          "Gross Salary", "Other Benefits", "Deduction", "Cheque No", "Total"
        ]],
        body,
        theme: 'grid',
        headStyles: { fillColor: [22, 78, 99], textColor: [255, 255, 255], fontStyle: 'bold' },
        styles: { fontSize: 8, textColor: [0, 0, 0] },
        columnStyles: {
          5: { halign: 'right' }, // Gross Salary
          6: { halign: 'right' }, // Other Benefits
          7: { halign: 'right' }, // Deduction
          9: { halign: 'right' }  // Total
        },
        didParseCell: (data) => {
          if (data.row.index === body.length - 1 && data.section === 'body') {
            // Style for Dept Total row
            data.cell.styles.fillColor = [241, 245, 249]; // Light gray
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.textColor = [51, 65, 85]; // Slate-700
          }
        },
        margin: { left: 14, right: 14 },
      });

      finalY = doc.lastAutoTable.finalY + 10;
    });

    // Grand Total table
    autoTable(doc, {
      startY: finalY,
      body: [[
        '', '', '', '', 'Grand Total:',
        grand.gross.toLocaleString(),
        grand.benefits.toLocaleString(),
        grand.deduction.toLocaleString(),
        '',
        grand.total.toLocaleString()
      ]],
      theme: 'grid',
      styles: { fontSize: 10, fontStyle: 'bold', textColor: [255, 255, 255] },
      columnStyles: {
        5: { halign: 'right' },
        6: { halign: 'right' },
        7: { halign: 'right' },
        9: { halign: 'right' }
      },
      didParseCell: (data) => {
        data.cell.styles.fillColor = [59, 130, 246]; // Blue-500
      },
      margin: { left: 14, right: 14 },
    });

    doc.save(`Payslip_Report_${getmonth}_${getyear}.pdf`);
  };

  const items = [
    {
      href: '/',
      title: (
        <span className="flex gap-2 items-center">
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-400 sm:text-lg md:text-xl font-black">Home</span>
        </span>
      ),
    },
    {
      href: '/payslip',
      title: (
        <span className="flex gap-2 items-center">
          <DocumentChartBarIcon className="h-6 w-6 text-gray-300" />
          <span className="text-gray-400 sm:text-lg  md:text-xl font-black">Pay Slip</span>
        </span>
      ),
    },
  ];

  return (
    <div>
      <div className="  p-2 md:px-6 pt-10" >
        <Breadcrumb items={items} />
      </div>

      <Spin spinning={loading}>
        {!loading && (
          <div className="bg-white shadow-md rounded-md p-4 md:px-6">
            <div ref={reportRef} className="pb-12">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Payslip Report</h2>
                <img src={logo} alt="Logo" className="w-24 md:w-32" />
              </div>

              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-200 text-sm text-left">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-2 border">Id</th>
                      <th className="px-4 py-2 border">First Name</th>
                      <th className="px-4 py-2 border">Designation</th>
                      <th className="px-4 py-2 border">Month</th>
                      <th className="px-4 py-2 border">Year</th>
                      <th className="px-4 py-2 border">Gross Salary</th>
                      <th className="px-4 py-2 border">Other Benefits</th>
                      <th className="px-4 py-2 border">Deduction</th>
                      <th className="px-4 py-2 border">Chequeno</th>
                      <th className="px-4 py-2 border">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const groupByDepartment = {};
                      const parse = val => parseFloat(val?.toString().replace(/,/g, '')) || 0;

                      reportData.forEach(emp => {
                        const dept = emp.TITLE || 'Unknown';
                        if (!groupByDepartment[dept]) groupByDepartment[dept] = [];
                        groupByDepartment[dept].push(emp);
                      });

                      const grandTotal = { gross: 0, benefits: 0, deduction: 0, total: 0 };
                      const rows = [];

                      Object.entries(groupByDepartment).forEach(([department, employees], i) => {
                        const deptTotal = { gross: 0, benefits: 0, deduction: 0, total: 0 };

                        const employeeRows = employees.map((emp, index) => {
                          const gross = parse(emp.GROSSSALARY);
                          const benefits = parse(emp.OTHERBENIFITS);
                          const deduction = parse(emp.DEDUCTION);
                          const total = parse(emp.TOTAL);

                          deptTotal.gross += gross;
                          deptTotal.benefits += benefits;
                          deptTotal.deduction += deduction;
                          deptTotal.total += total;

                          grandTotal.gross += gross;
                          grandTotal.benefits += benefits;
                          grandTotal.deduction += deduction;
                          grandTotal.total += total;

                          return (
                            <tr key={`${i}-${index}`}>
                              <td className="px-4 py-2 border">{emp.FKEMPID}</td>
                              <td className="px-4 py-2 border">{emp.FIRSTNAME}</td>
                              <td className="px-4 py-2 border">{emp.DESIGNATIONS}</td>
                              <td className="px-4 py-2 border">{emp.MONTHNAME}</td>
                              <td className="px-4 py-2 border">{emp.YEAR}</td>
                              <td className="px-4 py-2 border">{emp.GROSSSALARY}</td>
                              <td className="px-4 py-2 border">{emp.OTHERBENIFITS}</td>
                              <td className="px-4 py-2 border">{emp.DEDUCTION}</td>
                              <td className="px-4 py-2 border">{emp.CHEQUENO}</td>
                              <td className="px-4 py-2 border">{emp.TOTAL}</td>
                            </tr>
                          );
                        });

                        rows.push(
                          <tr key={`header-${i}`} className="bg-gray-200 font-semibold">
                            <td colSpan="10" className="px-4 py-2 border">{department}</td>
                          </tr>,
                          ...employeeRows,
                          <tr key={`total-${i}`} className="font-semibold bg-gray-100">
                            <td colSpan="5" className="px-4 py-2 border text-right">Department Total:</td>
                            <td className="px-4 py-2 border">{deptTotal.gross.toLocaleString()}</td>
                            <td className="px-4 py-2 border">{deptTotal.benefits.toLocaleString()}</td>
                            <td className="px-4 py-2 border">{deptTotal.deduction.toLocaleString()}</td>
                            <td className="px-4 py-2 border"></td>
                            <td className="px-4 py-2 border">{deptTotal.total.toLocaleString()}</td>
                          </tr>
                        );
                      });

                      rows.push(
                        <tr key="grand-total" className="font-bold bg-blue-100 text-blue-900">
                          <td colSpan="5" className="px-4 py-2 border text-right">Grand Total:</td>
                          <td className="px-4 py-2 border">{grandTotal.gross.toLocaleString()}</td>
                          <td className="px-4 py-2 border">{grandTotal.benefits.toLocaleString()}</td>
                          <td className="px-4 py-2 border">{grandTotal.deduction.toLocaleString()}</td>
                          <td className="px-4 py-2 border"></td>
                          <td className="px-4 py-2 border">{grandTotal.total.toLocaleString()}</td>
                        </tr>
                      );

                      return rows;
                    })()}
                  </tbody>
                </table>
              </div>

              <div className="text-sm text-gray-600 mt-4">
                Printed On: {getFormattedDateTime()} <br />
                Printed By: <span className="font-medium">Nizamuddin</span>
              </div>
            </div>

            <div className="mt-6 text-right">
              <Button onClick={generatePDF} type="primary" className="bg-blue-900 hover:bg-blue-700">
                Generate PDF
              </Button>
            </div>
          </div>
        )}
      </Spin>
    </div>
  );
}